import { Tabs } from '@/components/ui/daisy';
import { useTranslation } from 'react-i18next';

export enum QuestionFormTab {
  CONTENT = 'content',
  FEEDBACK = 'feedback',
}

type QuestionFormTabsProps = {
  value: QuestionFormTab;
  onChange: (tab: QuestionFormTab) => void;
};

export function QuestionFormTabs({ value, onChange }: QuestionFormTabsProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.questionsTab.createQuestionModal.questionForm',
  });

  return (
    <Tabs
      variant="box"
      className="w-fit"
      value={value}
      onChange={tab => onChange(tab as QuestionFormTab)}
    >
      <Tabs.Tab value={QuestionFormTab.CONTENT}>{t('contentTab')}</Tabs.Tab>
      <Tabs.Tab value={QuestionFormTab.FEEDBACK}>{t('feedbackTab')}</Tabs.Tab>
    </Tabs>
  );
}
